__turbopack_context__.v({
  "actionRow": "InscriptionActionRow-module__c1_GKq__actionRow",
});
